import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as invoiceActions from '../../../redux/invoices/actions';
import Spin from '../../../components/loading';
class AdditionalDetails extends React.Component {
  render() {
    let { error, loading, message, failed } = this.props;
    return (
      <>
        <Modal
          id="financial-transaction-modal"
          size='xl' isOpen={this.props.isOpen}>
          <ModalHeader>
            <div className="row">
              <div className="col-11">{locales('titles.financial.transaction.details')}</div>
              <div className="col-1 text-left">
                <a
                  href="#"
                  className=""
                  onClick={event => {
                    event.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  <i className="fas fa-times"></i>
                </a>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Spin spinning={loading}>
              <article>
                {error ? (
                  <div className="alert alert-danger">
                    {locales("messages.server.error")}
                  </div>
                ) :
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                  </>
                }
              </article>
            </Spin>
          </ModalBody>
          <ModalFooter>
            <button className='btn btn-success' onClick={() => this.props.closeModal()}>
              {locales('tables.close')}
            </button>
          </ModalFooter>
        </Modal >
      </>
    );
  }
};
const mapStateToProps = state => {
  return {
  }
}
const mapDispatchToProps = dispatch => {
  return {
    toggleStatus: (id, isActive) => dispatch(invoiceActions.toggleStatus(id, isActive)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDetails);
